var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProscons = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.2 181.7C105 181.7 103.9 181.3 103 180.4C101.2 178.6 101.2 175.8 103 174L175.1 101.9C176.9 100.1 179.7 100.1 181.5 101.9C183.3 103.7 183.3 106.5 181.5 108.3L109.4 180.4C108.5 181.3 107.4 181.7 106.2 181.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.8 136.7C117.3 136.7 115.3 134.7 115.3 132.2V123.2H106.3C103.8 123.2 101.8 121.2 101.8 118.7C101.8 116.2 103.8 114.2 106.3 114.2H115.3V105.2C115.3 102.7 117.3 100.7 119.8 100.7C122.3 100.7 124.3 102.7 124.3 105.2V114.2H133.3C135.8 114.2 137.8 116.2 137.8 118.7C137.8 121.2 135.8 123.2 133.3 123.2H124.3V132.2C124.3 134.7 122.2 136.7 119.8 136.7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.3 168.2H151.3C148.8 168.2 146.8 166.2 146.8 163.7C146.8 161.2 148.8 159.2 151.3 159.2H178.3C180.8 159.2 182.8 161.2 182.8 163.7C182.8 166.2 180.8 168.2 178.3 168.2Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.7 61.1C97 61.1 60.7 97.4 60.7 142.1C60.7 186.8 97 223.1 141.7 223.1C186.4 223.1 222.7 186.8 222.7 142.1C222.7 97.4 186.4 61.2 141.7 61.1ZM141.7 209.6C104.4 209.6 74.1999 179.4 74.1999 142.1C74.1999 104.8 104.4 74.6 141.7 74.6C179 74.6 209.2 104.8 209.2 142.1C209.2 179.4 179 209.6 141.7 209.6Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProscons, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/proscons.3ca3a6f3.svg";
export { ForwardRef as ReactComponent };